import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "./Dashboard.scss";
import { useMsal } from "@azure/msal-react";

/**
 * @description - Global dashboard(home landing page) component
 * @link Design Document -
 * @author Tharanga Niroshana <tharangan@unicorn-solutions.com>
 * @since 12/01/2025
 */
const Dashboard: React.FC<{}> = (props) => {
  const { t } = useTranslation();
  const { instance } = useMsal();

  const userName = useMemo(() => {
    return instance.getActiveAccount()?.name;
  }, [instance]);

  return (
    <div className={`home-followup home-followup-empty`}>
      <div className="home-greeting">
        <div className="line-1">
          {`${t("US.COLLECTION.HOME:HOME.HELLO")}! ${userName}`},
        </div>
        <div className="line-2">
          {`${t("US.COLLECTION.HOME:HOME.WELCOME_TO")} `}
          <strong>Resolve</strong>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
